module.exports = __webpack_public_path__ + "static/media/FiraSans-BlackItalic.6d2de0fc.ttf";